import BaseSliderBlock from "./BaseSliderBlock";
import Swiper, {Autoplay, Navigation, Pagination, SwiperOptions, Thumbs} from "swiper";

export default class Slider extends BaseSliderBlock {
	protected breakpointsBase = "container";
	protected mainWrapper: HTMLElement|null = null;
	protected thumbsWrapper: HTMLElement|null = null;
	protected wrapper: HTMLElement|null = null;

	init() {

		this.wrapper = this.block.querySelector(".slider");

		if (!(this.wrapper instanceof HTMLElement)) {
			return;
		}

		const mainSliderEl = this.block.querySelector(".swiper-main");
		const thumbsSliderEl = this.block.querySelector(".swiper-thumbs");


		if (mainSliderEl instanceof HTMLElement) {
			const customOptions = JSON.parse(String(mainSliderEl.dataset.options));
			this.mainWrapper = this.block.querySelector(".slider-main");

			if (!(this.mainWrapper instanceof HTMLElement)) {
				return;
			}

			let options: SwiperOptions = {
				loop: true,
				modules: [Navigation, Pagination],
				breakpointsBase: this.breakpointsBase,
				pagination: this.getDefaultPagination(this.mainWrapper),
				navigation: this.getDefaultNavigation(this.mainWrapper),
				// on: {
				// 	init: () => {
				// 		this.setNavigationVisibility();
				// 	},
				// 	resize: () => {
				// 		this.setNavigationVisibility();
				// 	}
				// },
				...customOptions
			};

			if (options.autoplay) {
				options.modules?.push(Autoplay);
			}

			if (thumbsSliderEl instanceof HTMLElement) {
				this.thumbsWrapper = this.block.querySelector(".slider-thumbs");
				if (this.thumbsWrapper instanceof HTMLElement) {
					const thumbsSwiper = new Swiper(thumbsSliderEl, {
						slidesPerView: 4,
						spaceBetween: 10,
						watchSlidesProgress: true,
						breakpoints: {
							728: {
								slidesPerView: 6
							},
							1240: {
								slidesPerView: 7
							},
							1540: {
								slidesPerView: 8
							},
						},
						navigation: this.getDefaultNavigation(this.thumbsWrapper),
						modules: [Navigation]
					});

					if (thumbsSwiper) {
						options.modules?.push(Thumbs);
						options.thumbs = {
							swiper: thumbsSwiper
						};
					}
				}

			}

			new Swiper(mainSliderEl, options);
		}
	}

	protected setNavigationVisibility(): void {
		if (!(this.wrapper instanceof HTMLElement) || !(this.mainWrapper instanceof HTMLElement)) {
			return;
		}

		const prevBtn = this.mainWrapper.querySelector(".slider-btn-prev");
		const nextBtn = this.mainWrapper.querySelector(".slider-btn-next");

		if (!(prevBtn instanceof HTMLElement) || !(nextBtn instanceof HTMLElement)) {
			return;
		}

		if (window.innerWidth - this.wrapper.offsetWidth > 168) {
			prevBtn.style.display = 'block';
			nextBtn.style.display = 'block';
		} else {
			prevBtn.style.display = 'none';
			nextBtn.style.display = 'none';
		}
	}
}
